import styled from 'styled-components';

export const Photo = styled.div`
  width: 100%;
  height: 268px;
  background-color: ${({ bgColor }) => bgColor};
  background-image: url(${({ image }) => image});
  background-size: ${({ placeholder }) => (placeholder ? '40%' : 'cover')};
  background-repeat: no-repeat;
  background-position: center center;
  transition: all 0.1s ease-in;
  margin-bottom: 24px;
`;

export const Container = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &:hover ${Photo} {
    transform: scale(1.05);
    box-shadow: 0 0 6px 2px rgb(0 0 0 / 6%);
  }
`;

export const Description = styled.div`
`;

export const Title = styled.h2`
  line-height: 22px;
`;
